import './supDashboardTable.css';
import { useEffect, useState } from 'react';
import { standardDate } from '../../../utils/formatDate';
import { useParams } from 'react-router-dom';

export default function SupDashboardTable({ tableData, selectedOrg }) {
    const { mode } = useParams();
    const [rowClickId, setRowClickId] = useState(0);
    const tableHeader = ['Name', 'Date', 'Days/Nights', 'Slots', 'Start City and Price', 'Difficulty', 'Status'];

    useEffect(() => {
        if (rowClickId) {
            console.log('Clicked ID:', rowClickId);

            window.open(`/support/${mode}/trip/date/${selectedOrg}/${rowClickId}`, '_blank');
        }
    }, [rowClickId, mode]);

    const getStartCity = (row) => {
        const city = row?.startCities?.map((item) => {
            return `${item?.city ?? 'N/A'} - ₹${item?.price.total ?? 'N/A'}, `;
        });
        return city;
    };

    return (
        <>
            <div className='table-top-container'>
                <table className='table'>
                    <thead className='tableHead'>
                        <tr>
                            {tableHeader.map((head, headIndex) => {
                                return <th key={headIndex}>{head}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData?.map((row, rowIndex) => {
                            return (
                                <tr
                                    key={rowIndex}
                                    className='tableBodyRow allowCLick'
                                    onClick={() => setRowClickId(row._id)}
                                >
                                    <td className='ellipsisCell'>{row.name ?? 'N/A'}</td>
                                    <td>{standardDate(row.startDate) ?? 'N/A'}</td>
                                    <td>{`${row.days ?? 'N/A'} days/${row.nights ?? 'N/A'} nights`}</td>
                                    <td>{`${row.bookedSlots ?? 'N/A'}/${row.totalSlots ?? 'N/A'}`}</td>
                                    <td className='ellipsisCell'>{getStartCity(row)}</td>
                                    <td>{row.difficulty ?? 'N/A'}</td>
                                    <td>{row.status ?? 'N/A'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className='responsiveCardContainer'>
                    {tableData?.map((row, rowIndex) => (
                        <div key={rowIndex} className='responsiveCard' onClick={() => setRowClickId(row._id)}>
                            <div className='cardContent'>
                                <p>
                                    <strong>{tableHeader[0]}</strong> {row.name ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[1]}</strong> {standardDate(row.startDate) ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[2]}</strong>{' '}
                                    {`${row.days ?? 'N/A'} days / ${row.nights ?? 'N/A'} nights`}
                                </p>
                                <p>
                                    <strong>{tableHeader[3]}</strong>{' '}
                                    {`${row.bookedSlots ?? 'N/A'} / ${row.totalSlots ?? 'N/A'}`}
                                </p>
                                <p>
                                    <strong>{tableHeader[4]}</strong> {getStartCity(row)}
                                </p>
                                <p>
                                    <strong>{tableHeader[5]}</strong> {row.difficulty ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[6]}</strong> {row.status ?? 'N/A'}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
